import { useState, useCallback } from "react"
import axios from "axios"
import { METHOD } from "./constants"
// import { setToken } from "../slices/tokenSlice"
// import { supabase } from "../supabase"

const serialize = function (obj) {
    var str = [];
    for (var p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
    return str.join("&");
}

export default function useApi() {
    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState(null)
    const [error, setError] = useState(null)
    const token = localStorage.getItem("token");

    const callApi = useCallback(async ({ api, param, body, query, customApplication }) => {
        if (isLoading) return;
        try {
            setError(null);
            let config;
            let { url, method } = api || {};
            let response = null;

            setIsLoading(true)

            if (token?.length > 16) {
                config = {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'x-app-id': customApplication ? customApplication : 'ecommerce_mobile_app',
                    }
                }
            } else {
                config = {
                    headers: {
                        'x-app-id': customApplication ? customApplication : 'ecommerce_mobile_app',
                    }
                };
            }

            if (Array.isArray(param)) {
                url = url + param.join("/")
            } else if (param || param === 0) {
                url = url + param;
            }

            if (query) {
                const queryString = serialize(query);
                url = `${url}?${queryString}`;
            }

            switch (method) {
                case METHOD.POST:
                    response = await axios.post(url, body, config)
                    break;
                case METHOD.GET:
                    response = await axios.get(url, config)
                    break;
                case METHOD.PATCH:
                    response = await axios.patch(url, body, config)
                    break;
                case METHOD.PUT:
                    response = await axios.put(url, body, config)
                    break;
                case METHOD.DELETE:
                    response = await axios.delete(url, config)
                    break;
                default:
                    return;
            }
            setData(response.data)
            setIsLoading(false)
            return response.data
        } catch (error) {
            setIsLoading(false);
            if (error?.response?.data) {
                setError(error?.response?.data);
                // Throw the actual error response data instead of creating a new Error object
                throw error?.response?.data;
            } else {
                const errorObj = { error: error?.message };
                setError(errorObj);
                throw errorObj;
            }
        }
    }, [token, setError])

    return { callApi, isLoading, data, error: error?.error }
}